import { mapStrings } from "../../lib/frTypo";

/**
 * "Halloween" reel — on-screen copy, FR only for now.
 *
 * Story, not a claim: a bank screen full of everyday purchases melts and
 * falls apart, the Frak logo re-forms it and the balance is filled again.
 * The balance and the prices are illustrative (it is a drawn screen); no
 * Frak reward amount, percentage or earnings figure is shown anywhere.
 *
 * Sources:
 *   - button → the widget's own label, as the team wrote it: "Partager et
 *              Gagner" (B2C capture `public/Order_confirmed.png`, B2B
 *              Share scene "Partager & gagner"). It triggers the rescue.
 *   - relief → the team's brief (tutoiement, no hype). The opening has no
 *              line: the falling balance carries it.
 *   - items, extras → the team's brief: everyday purchases, nothing
 *              branded. Prices are plausible, in €, and sum to about the
 *              opening balance (`BAL.start` in `HalloweenReel`).
 *   - end → same as the Quiz reel (landing hero.title; faq.a1 free,
 *           faq.a3 no followers, /vs cash)
 * The relief is split per line; the last line gets the accent.
 */
export const HALLOWEEN = mapStrings({
  relief: ["Frak remplit", "ton compte bancaire"],
  balance: "Solde",
  /** The five rows of the screen, top to bottom. */
  items: [
    { name: "Sac", price: 89 },
    { name: "Jeans", price: 79 },
    { name: "Crème de jour", price: 24 },
    { name: "Pull", price: 59 },
    { name: "Baskets", price: 95 },
  ],
  /** Extra debits that fly out with them. */
  extras: [
    { name: "Parfum", price: 64 },
    { name: "Écharpe", price: 29 },
    { name: "Livre", price: 18 },
    { name: "Sweat", price: 55 },
    { name: "Casquette", price: 24 },
    { name: "Montre", price: 85 },
  ],
  button: "Partager et Gagner",
  end: {
    line: "Gagne de l'argent en recommandant ce que tu aimes.",
    sub: "Gratuit. Sans abonnés. Du vrai cash.",
  },
});
